import * as React from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { LatLngBounds, divIcon } from "leaflet";
import "./styles.css";
import "leaflet/dist/leaflet.css";
import { cn } from "@/shared/lib/utils";
import type { ProjectsType } from "@/entities/projects/model/types";
import { ProjectMapCard } from "@/shared/ui/cards/ProjectMapCard";

export interface IMapProps {
    className?: string;
    wpClassName?: string;
    projects: ProjectsType
}

const FitBounds = ({ points }: { points: [number, number][] }) => {
    const map = useMap();

    React.useEffect(() => {
        if (points.length === 0) return;

        const bounds = new LatLngBounds(points);
        map.fitBounds(bounds, { padding: [50, 50] });
    }, [points, map]);

    return null;
};

const createCustomIcon = (name: string) => {
    return divIcon({
        className: "custom-div-icon",
        html: `
            <div class="relative flex flex-col items-center">
                
                <div class="font-manrope text-[10px] font-medium uppercase whitespace-nowrap bg-white shadow-bg rounded-[10px] h-[34px] px-[12px] flex justify-center items-center">
                    ${name}
                </div>

                <!-- Треугольник -->
                <div style="
                    width: 0;
                    height: 0;
                    border-left: 6px solid transparent;
                    border-right: 6px solid transparent;
                    border-top: 8px solid white;
                    pointer-events: none;
                    
                "></div>

            </div>
        `,
        iconSize: [26, 26],
        iconAnchor: [13, 26],
    });
};

export function Map({ className, wpClassName, projects }: IMapProps) {
    const defaultCenter: [number, number] = projects.length > 0 ? projects[0].location.coordinates : [51.505, -0.09];

    return (
        <div className={cn(
            "relative w-full overflow-hidden rounded-[10px]",
            wpClassName
        )}>
            <div
                className={cn(
                    "relative z-0 h-[400px] w-full md:h-[450px]",
                    className
                )}
            >
                <MapContainer
                    center={defaultCenter}
                    zoom={14}
                    scrollWheelZoom={false}
                    className="h-full w-full"
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <FitBounds points={projects.map((p) => p.location.coordinates)} />

                    {projects.map((project, index) => {

                        return (
                            <Marker
                                key={index}
                                position={project.location.coordinates}
                                icon={createCustomIcon(project.title)}
                            >
                                <Popup 
                                    offset={[0, -15]}
                                >
                                    <ProjectMapCard
                                        project={project}
                                    />
                                </Popup>
                            </Marker>
                        );
                    })}
                </MapContainer>
            </div>
        </div>
    );
}
